import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal, Form, message, Radio } from 'antd';
import { Select } from 'components/Form';
import { connect } from 'react-redux';
import { changeLicenceFilter } from 'store/actions/saveLicenceFilter';
import { useT } from 'hooks/Locale/useT';

import apiClient from 'utils/apiClient';
import { useNavigate } from 'react-router-dom';

const mapDispatchToProps = (dispatch: any) => ({
  changeLicenceFilter: (formData: any) => dispatch(changeLicenceFilter(formData))
});

type OwnerType = 'CUSTOMER' | 'ORGANIZATION';

const LicenceCreateModal = ({
  showAddNewLicence, setShowAddNewLicence,
  customers, organizations, customersLoading, form,
  customer, changeLicenceFilter
}: any) => {
  const t = useT();
  // CSV-1964: a licence belongs to a customer or to a reseller organization. Organization-owned
  // programs can only receive a FEATURE grant through the organization's own licence, and until
  // now such licences could only appear as a side effect of a reseller creating a service.
  const [ownerType, setOwnerType] = useState<OwnerType>('CUSTOMER');

  const navigate = useNavigate();

  const resetForm = () => {
    setOwnerType('CUSTOMER');
    form.setFieldsValue({ customer: customer || null, organization: null });
  };

  const submitForm = async (values: any) => {
    try {
      const payload = ownerType === 'ORGANIZATION'
        ? { organizationId: values.organization }
        : { customerId: values.customer };
      const response: any = await apiClient.request(`/api/v1/licences`, payload, 'POST');

      if (ownerType === 'CUSTOMER') {
        changeLicenceFilter(values.customer);
      }

      navigate(`/licensing/manage-licences/${response.id}/edit`);
    } catch (error) {
      console.error(error);
      message.error(t('error.data_load'));
    }
  }

  const filterOption = (input: string, option: any) =>
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  return (
    <Modal
      open={showAddNewLicence}
      title={t('licensing.add_new_licence')}
      okText={t('general.submit')}
      cancelText={t('general.back')}
      onOk={form.submit}
      onCancel={() => {
        setShowAddNewLicence(false);
        resetForm();
      }
      }
    >
      <Form form={form} onFinish={submitForm}>
        {organizations ?
          <Form.Item label={t('general.owner_type')}>
            <Radio.Group value={ownerType} onChange={(el: any) => setOwnerType(el.target.value)}>
              <Radio value="CUSTOMER"><FormattedMessage id='general.customer'/></Radio>
              <Radio value="ORGANIZATION"><FormattedMessage id='general.reseller'/></Radio>
            </Radio.Group>
          </Form.Item>
          : null}
        {ownerType === 'ORGANIZATION' ?
          <Select
            showSearch
            customLayout
            name="organization"
            label={t('general.reseller')}
            customRules={[{ required: true, message: t('validation.field_required') }]}
            manualOptions={organizations}
            filterOption={filterOption}
            loading={customersLoading}
          />
          : customers ? <Select
            showSearch
            customLayout
            name="customer"
            label={t('general.customer')}
            customRules={[{ required: true, message: t('validation.field_required') }]}
            manualOptions={customers}
            filterOption={filterOption}
            loading={customersLoading}
          /> : null}
      </Form>
    </Modal>
  );
}

export default connect(null, mapDispatchToProps)(LicenceCreateModal);
